"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.instructions = void 0;
const plugin_audio_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-audio-multi-response"));
const __1 = require("../../..");
// @ts-ignore
const helpers_1 = require("../../shared/helpers");
// @ts-ignore
const taskSetup_1 = require("../../taskSetup");
const taskStore_1 = require("../../../taskStore");
const instructionData = [
    {
        prompt: 'inferenceInstructions2',
        buttonText: 'Go',
    },
    {
        prompt: 'inferenceInstructions',
        buttonText: 'Continue',
    },
];
const replayButtonHtmlId = 'replay-btn-revisited';
exports.instructions = instructionData.map((data) => {
    return {
        type: plugin_audio_multi_response_1.default,
        stimulus: () => __1.mediaAssets.audio[data.prompt],
        prompt: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            return `<div class="lev-stimulus-container">
                        <button
                            id="${replayButtonHtmlId}"
                            class="replay"
                        >
                            ${helpers_1.replayButtonSvg}
                        </button>
                        <div class="lev-row-container instruction">
                            <p>${t[data.prompt]}</p>
                        </div>
                    </div>`;
        },
        prompt_above_buttons: true,
        button_choices: ['Next'],
        button_html: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            return [
                `<button class="primary">
            ${[data.buttonText]}
            </button>`,
            ];
        },
        keyboard_choices: () => 'NO_KEYS',
        on_load: () => {
            const pageStateHandler = new helpers_1.PageStateHandler(data.prompt, true);
            (0, helpers_1.setupReplayAudio)(pageStateHandler);
        },
        on_finish: () => {
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
                assessment_stage: 'instructions',
            });
        },
    };
});
